import App from './connectToStore';
export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js